import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import classes from './Additional.module.scss';
import { useSelector } from 'react-redux';
import { versionSelector } from '@store/models/user/selectors';
import { additionalList, additionalTitle } from '@configs/additional';
import SubscriptionCard from './SubscriptionCard/SubscriptionCard';
import Slider from '@components/shared/Slider/Slider';
import { triggerMetricsEvent } from '@metrics';
const Additional = () => {
    const version = useSelector(versionSelector);
    const blockClasses = classNames(classes.subscription, 'grid-block', classes[version]);
    const handleScroll = () => {
        triggerMetricsEvent({ element: 'additionalCardsScroll' });
    };
    return (_jsxs("section", { className: blockClasses, "data-testid": "additional", children: [_jsx("h2", { className: classes.title, children: additionalTitle[version] }), _jsx(Slider, { className: classes.slider, slideClass: classes.slide, onScroll: handleScroll, children: additionalList[version].map(el => {
                    const isSoonCard = el.name === 'soon';
                    return _jsx(SubscriptionCard, { element: el, isButtonShown: !isSoonCard, variant: isSoonCard ? 'div' : 'link' }, el.name);
                }) })] }));
};
export default Additional;
